import React, { useState } from "react";
import { Box, MenuItem, Typography, useMediaQuery } from "@mui/material";
import { ImageSettings } from "../../../../Helper";
import ArrowUpIcon from "../../../../Custom-imeges/ArrowUpIcon";
import ArrowDown from "../../../../Custom-imeges/ArrowDown";
import SeedParameter from "../../../SharedSuite/SeedParameter";

interface SuiteAppSettingsProps {
  imageSettings: ImageSettings | undefined;
  handleSelectModel?: ((model: string) => void) | undefined;
  handleSelectSize?: ((size: string) => void) | undefined;
  toggleLockSeed?: (flag: boolean) => void;
  openLockSeed?: boolean;
  selectedModel?: string | undefined;
  selectedSize?: string | undefined;
  showSetting: {
    models: boolean;
    dimensions: boolean;
    seed: boolean;
  };
  seedValue?: number | null;
}

export const SuiteAppSettings = ({
  imageSettings,
  handleSelectModel,
  handleSelectSize,
  selectedModel,
  selectedSize,
  showSetting,
  toggleLockSeed,
  openLockSeed,
  seedValue,
}: SuiteAppSettingsProps) => {
  const [showMoreSettings, setShowMoreSettings] = useState(false);
  const [isModelListOpen, setIsModelListOpen] = useState(true);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const handleToggleShowMoreSettings = () => {
    setShowMoreSettings(!showMoreSettings);
  };

  const handleSelectModelChange = (model: string) => {
    if (handleSelectModel) {
      handleSelectModel(model);
    }
  };

  const handleSelectSizeChange = (size: string) => {
    if (handleSelectSize) {
      handleSelectSize(size);
    }
  };

  return (
    <Box
      sx={{ width: "100%", my: "24px" }}
      className="suite-app-settings-container"
    >
      {showSetting.models && (
        <Box
          sx={{
            width: "100%",
            paddingBottom: " 16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom:1
            }}
          >
            <Typography className="settings-title">
              Model
            </Typography>
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <span
              className="arrow-container d-flex justify-content-center align-items-center"
              onClick={() => setIsModelListOpen(!isModelListOpen)}
            >
              {isMobile?isModelListOpen ? (
                <ArrowUpIcon className="return-versions-arrow-white-black" />
              ) : (
                <ArrowDown className="return-versions-arrow-white-black" />
              ):null}
            </span>
          </Box>
          </Box>
          {(!isMobile || isModelListOpen) &&(

          <Box className="list">
            {imageSettings?.imageModels.map((model, i) => (
              <MenuItem
                key={i}
                className={`list-item ${
                  model.modelVersion === selectedModel && "selected-model"
                }`}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => handleSelectModelChange(model.modelVersion)}
              >
                <Typography className="list-item-title">
                  {model.modelName}
                </Typography>
              </MenuItem>
            ))}
          </Box>
          )}
        </Box>
      )}
      {showSetting.dimensions && (
        <Box className="suite-app-settings">
          <Box
            className={`suite-app-settings-header ${
              showMoreSettings && "mb-2"
            }`}
          >
            <Typography>More Settings</Typography>
            <Box
              sx={{ cursor: "pointer" }}
              onClick={handleToggleShowMoreSettings}
            >
              {showMoreSettings ? (
                <ArrowUpIcon className="show-more-settings-icn" />
              ) : (
                <ArrowDown className="show-more-settings-icn" />
              )}
            </Box>
          </Box>
          {showMoreSettings && (
            <>
              <Box
                sx={{
                  width: "100%",
                  paddingBottom: "12px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    className="settings-title"
                    sx={{ marginBottom: 1 }}
                  >
                    Dimensions
                  </Typography>
                </Box>

                <Box className="list">
                  {imageSettings?.imageDimensions.map((size, i) => (
                    <MenuItem
                      key={i}
                      className={`list-item ${
                        size === selectedSize && "selected-size"
                      }`}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                      }}
                      onClick={() => handleSelectSizeChange(size)}
                    >
                      <Box
                        className={`item-size-${size?.replace(":", "-")}`}
                      ></Box>
                      <Typography className="list-item-title">
                        {size}
                      </Typography>
                    </MenuItem>
                  ))}
                </Box>
              </Box>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};
